import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { EchartService } from './services/echart.service';
@Component({
  selector: 'graphic-echarts',
  templateUrl: './graphic-echarts.component.html',
  styleUrls: ['./graphic-echarts.component.scss']
})
export class GraphicEchartsComponent implements OnInit {
  @ViewChild('chartContainer', { static: true }) chartContainer: ElementRef;
  @Input() options: any;
  @Input() width: string = '0px';
  @Input() height: string = '0px';
  echartsInstance: any;

  constructor(private readonly echartService: EchartService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.initChart();
    }, 100);
  }

  ngOnChanges(): void {
    if (this.echartsInstance) {
      this.echartService.updateChart(this.echartsInstance, this.options);
    }
  }

  initChart(): void {
    const chartElement = this.chartContainer.nativeElement;
    this.echartsInstance = this.echartService.renderChart(chartElement, this.options);
  }
}
